export default function IconA1() {
    return (
        <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.93171 22.7859H6.65226C6.45831 22.7859 6.29497 22.922 6.25754 23.1126L5.75733 25.7735C5.70969 26.0219 5.90025 26.2499 6.15206 26.2499H18.3374C18.5994 26.2499 18.7934 26.0015 18.7253 25.7463L18.3374 24.2695"
                stroke="black"
                strokeWidth="0.875"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.9624 1.75V24.7392H8.9424C10.2389 24.7392 11.2733 23.6537 11.2087 22.3572L10.3137 3.98903C10.2525 2.73681 9.21803 1.75 7.9624 1.75Z"
                stroke="black"
                strokeWidth="0.875"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.7946 23.9157C13.274 23.4767 13.2093 23.0956 13.2434 22.3572L14.1383 3.98903C14.2029 2.73681 15.2374 1.75 16.4896 1.75V18.9817"
                stroke="black"
                strokeWidth="0.875"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M10.4055 5.88794H14.0397" stroke="black" strokeWidth="0.875" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.1856 22.7859H11.212" stroke="black" strokeWidth="0.875" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M15.7139 20.3426C15.7819 20.1283 15.9827 19.9819 16.2073 19.9819H18.984H22.0124C22.2472 19.9819 22.4514 20.1385 22.5126 20.363L23.5097 24.038C23.7036 24.7492 23.1728 25.4502 22.4344 25.4604C21.9886 25.4672 21.5803 25.2052 21.3931 24.7969L20.784 23.4528H17.1465L16.585 24.7969C16.4149 25.2052 16.0167 25.4706 15.5744 25.4706C14.8326 25.4706 14.3051 24.7492 14.5331 24.0448L15.7139 20.3426Z"
                stroke="black"
                strokeWidth="0.875"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.8181 16.5828C20.8181 16.5828 21.4646 17.6717 20.6411 18.0119C19.8177 18.3522 19.0861 16.3548 19.0861 17.6955V19.9821"
                stroke="black"
                strokeWidth="0.875"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.7807 22.3777C21.0813 22.3777 21.3251 22.134 21.3251 21.8333C21.3251 21.5326 21.0813 21.2888 20.7807 21.2888C20.48 21.2888 20.2362 21.5326 20.2362 21.8333C20.2362 22.134 20.48 22.3777 20.7807 22.3777Z"
                fill="black"
            />
            <path
                d="M17.8339 22.3777C18.1346 22.3777 18.3783 22.134 18.3783 21.8333C18.3783 21.5326 18.1346 21.2888 17.8339 21.2888C17.5332 21.2888 17.2894 21.5326 17.2894 21.8333C17.2894 22.134 17.5332 22.3777 17.8339 22.3777Z"
                fill="black"
            />
        </svg>
    );
}
